import React from 'react';
import BILButtonPSD2 from './BILButtonPSD2';
import './Button.less';

const BILFooterButtonsPSD2 = (props) => {

    return (
        <div className={'bil-button-group-container'}>
            <BILButtonPSD2
                id={props.id}
                text={props.buttonType === "cancel" ? 'account-selection.button-cancel' : 'account-selection.button-continue'}
                type={props.buttonType}
                enabled={true}
                onClick={props.onClick}
            />
        </div>
    )
}

export default (BILFooterButtonsPSD2);
